import * as Yup from "yup";

export const dataModel = {
  variety: "",
  dateInit: "",
  dateEnd: "",
  varietyItemCodeProcessed: ""
};

export const validationDataModel = Yup.object().shape({
    variety: Yup.string().optional("forms.validations.required"),
    varietyItemCodeProcessed: Yup.string().optional("forms.validations.required"),
    dateInit: Yup.date().optional("forms.validations.required"),
    dateEnd: Yup.date().optional("forms.validations.required"),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
